"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuiStandardProvider = void 0;
const protocol_1 = require("../../protocol");
const utils_1 = require("../../utils");
const media_1 = require("../../utils/media");
class SuiStandardProvider {
    constructor(wallet) {
        this.wallet = wallet;
    }
    getVersion() {
        return this.wallet.version;
    }
    supportChains(chains) {
        if (chains.length === 1 && chains[0] === protocol_1.SUI_CHAINS.MAINNET) {
            return true;
        }
        return false;
    }
    send(request) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // await this.restoreConnect()
                (0, utils_1.logDebug)("suiProvider send request:", JSON.stringify(request));
                const method = request.method;
                let result;
                if (request.injectParams && this.wallet) {
                    let originalRarams = request.injectParams;
                    switch (method) {
                        case "sui_signTransactionBlock":
                            let injectSignResult;
                            if (this.wallet.features['sui:signTransaction']) {
                                injectSignResult = yield this.wallet.features['sui:signTransaction'].signTransaction(originalRarams);
                            }
                            else if (this.wallet.features['sui:signTransactionBlock']) {
                                injectSignResult = yield this.wallet.features['sui:signTransactionBlock'].signTransactionBlock(originalRarams);
                            }
                            else {
                                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
                            }
                            //{transactionBlockBytes: 'AAACAAhmAAAAAAAAAAAgcveY+LcJkCRT1LtVxlZh6eBBVKUGdl…7bLNXSJ4Qz1jZurage0aGdH6Zb+4CAAAAAAAAIAo1AAAAAAAA', hash: '2pxcesyfKVCs3EegDYUDeQ28m3V3tn5VR32aUZSdg3dc', signature: 'ADDzSloxm5wEQX4BaTMJEON9t/xGgZ66ybiy5uT4TUimdl6Q9/…NeA3YOy/QsAD4XwjQ0rSuNkeKyfNy+VZPtJsmnKWswbGHSw=='}
                            result = {
                                method: "sui_signTransactionBlock",
                                result: injectSignResult === null || injectSignResult === void 0 ? void 0 : injectSignResult.signature
                            };
                            break;
                        case "sui_signAndExecuteTransactionBlock":
                            let injectSendResult;
                            if (this.wallet.features['sui:signAndExecuteTransaction']) {
                                injectSendResult = yield this.wallet.features['sui:signAndExecuteTransaction'].signAndExecuteTransaction(originalRarams);
                            }
                            else if (this.wallet.features['sui:signAndExecuteTransactionBlock']) {
                                injectSendResult = yield this.wallet.features['sui:signAndExecuteTransactionBlock'].signAndExecuteTransactionBlock(originalRarams);
                            }
                            else {
                                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
                            }
                            result = {
                                method: "sui_signAndExecuteTransactionBlock",
                                result: injectSendResult.digest
                            };
                            break;
                        case "sui_signMessage":
                            const injectResult = yield this.wallet.features['sui:signMessage'].signMessage(originalRarams);
                            result = {
                                method: "sui_signMessage",
                                result: injectResult.signature
                            };
                            break;
                        case "sui_signPersonalMessage":
                            const injectPersonalResult = yield this.wallet.features['sui:signPersonalMessage'].signPersonalMessage(originalRarams);
                            result = {
                                method: "sui_signPersonalMessage",
                                result: injectPersonalResult.signature
                            };
                            break;
                    }
                }
                return result;
            }
            catch (e) {
                (0, utils_1.logDebug)("suiProvider send error:", e);
                throw e;
            }
        });
    }
    addAccountChangedListener() {
    }
    removeListener() {
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
        });
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.wallet.features['standard:connect'].connect();
        });
    }
    restoreConnect() {
        if ((0, media_1.isDevice)("mobile")) {
            return this.connect();
        }
        return Promise.resolve();
    }
    getAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            let firstAccount = yield this.connect();
            if (!firstAccount) {
                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR);
            }
            let address = (_a = firstAccount === null || firstAccount === void 0 ? void 0 : firstAccount.address) !== null && _a !== void 0 ? _a : "";
            let publicKey = (_b = firstAccount === null || firstAccount === void 0 ? void 0 : firstAccount.publicKey) !== null && _b !== void 0 ? _b : "";
            if (publicKey instanceof Uint8Array) {
                publicKey = this.normalizeUint8Array(publicKey);
                publicKey = btoa(String.fromCharCode(...publicKey));
            }
            let extra = {};
            extra[protocol_1.SUI_CHAINS.MAINNET] = { publicKey: publicKey };
            return {
                namespace: protocol_1.NameSpaceKeySui,
                addresses: [`${protocol_1.SUI_CHAINS.MAINNET}:${firstAccount.address}`],
                methods: firstAccount.features,
                extra: extra
            };
        });
    }
    normalizeUint8Array(data) {
        if (data.length === 33 && data[0] === 0) {
            return data.slice(1);
        }
        return data;
    }
}
exports.SuiStandardProvider = SuiStandardProvider;
